import { LOCAL_DEVELOPMENT_VERSION } from '../constants/constants';

export const devLabel = 'DEV VERSION';

export const checkAppVersionCompatibility = (
  appVersion: string,
  backendVersion: string,
) => {
  const [appMajor, appMinor, appPatch] = extractVersionParts(appVersion);
  const [backendMajor, backendMinor, backendPatch] =
    extractVersionParts(backendVersion);

  return (
    appMajor === backendMajor &&
    (appMinor < backendMinor ||
      (appMinor == backendMinor && appPatch <= backendPatch))
  );
};

function extractVersionParts(version: string) {
  return version.split('.').map(Number);
}

export function getMinorVersion(text: string) {
  const m = text.match(/^\d+\.(\d+)/);
  return m ? Number(m[1]) : NaN;
}

export function isLocalDevelopmentVersion(version: string) {
  return version === LOCAL_DEVELOPMENT_VERSION;
}

// Keep this rule in sync with apps/electron-main/public/splash-screen.template.html.
export function isDevVersion(version: string) {
  const minor = getMinorVersion(version);
  return minor % 2 === 0;
}
